import { stripLoginId } from '../utils';

// ─── v4 API — Authenticated trading WebSocket (OTP URL) ───────────────────────

export const subscribeToBalance = () => ({
    balance: 1,
    subscribe: 1,
});

export const unsubscribeFromBalance = () => ({
    forget_all: 'balance',
});

export const subscribeToOpenContract = (contractId) => ({
    proposal_open_contract: 1,
    subscribe: 1,
    contract_id: contractId,
});

export const getContractInfo = (contractId) => ({
    proposal_open_contract: 1,
    contract_id: contractId,
});

export const subscribeToAllOpenContracts = () => ({
    proposal_open_contract: 1,
    subscribe: 1,
});

export const unsubscribeFromAllOpenContracts = () => ({
    forget_all: 'proposal_open_contract',
});

export const subscribeToTransactions = (options) => ({
    transaction: 1,
    subscribe: 1,
    ...stripLoginId(options),
});

export const unsubscribeFromTransactions = () => ({
    forget_all: 'transaction',
});

export const getStatement = (options) => ({
    statement: 1,
    ...stripLoginId(options),
});

export const getPortfolio = (options) => ({
    portfolio: 1,
    ...stripLoginId(options),
});

export const getProfitTable = (options) => ({
    profit_table: 1,
    ...stripLoginId(options),
});

// ─── v3-only — Not available on v4 OTP connections ────────────────────────────

/**
 * @deprecated v3 only. Not available in the Deriv v4 API.
 * Use `GET /trading/v1/options/accounts` via `DerivREST.getAccounts` for
 * account-level information.
 */
/* istanbul ignore next -- v3-only */
export const getAccountLimits = () => ({
    get_limits: 1,
});

/**
 * @deprecated v3 only. Not available in the Deriv v4 API.
 */
/* istanbul ignore next -- v3-only */
export const getAccountSettings = () => ({
    get_settings: 1,
});

/**
 * @deprecated v3 only. Not available in the Deriv v4 API.
 */
/* istanbul ignore next -- v3-only */
export const getAccountStatus = () => ({
    get_account_status: 1,
});

/**
 * @deprecated v3 only. Not available in the Deriv v4 API.
 * In v4, trading durations are served as static data (`LiveApi.tradingDurations`)
 * or via `LiveApi.getTradingDurations()` which returns the static list.
 */
/* istanbul ignore next -- v3-only */
export const getTradingDurations = () => ({
    trading_durations: 1,
});

/**
 * @deprecated v3 only. Not available in the Deriv v4 API.
 */
/* istanbul ignore next -- v3-only */
export const getSelfExclusion = () => ({
    get_self_exclusion: 1,
});

/**
 * @deprecated v3 only. Not available in the Deriv v4 API.
 * In v4, terminate a session by closing the WebSocket connection.
 */
/* istanbul ignore next -- v3-only */
export const logOut = () => ({
    logout: 1,
});

/**
 * @deprecated v3 only. Not available in the Deriv v4 API.
 */
/* istanbul ignore next -- v3-only */
export const getRealityCheckSummary = () => ({
    reality_check: 1,
});
